import React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";

import { cn } from "@/lib/utils";

const Checkbox = React.forwardRef<
  React.ComponentRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer h-[18px] w-[18px] shrink-0 rounded-sm text-brand-600 border border-grey-300 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-brand-600 data-[state=checked]:border-brand-600 print:data-[state=checked]:border-brand-600 data-[state=checked]:text-brand-foreground print:data-[state=checked]:text-brand-600",
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="text-current">
      <Check className="h-[15px] w-[15px]" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));

export { Checkbox };
